export default __webpack_public_path__ + "static/media/login.a006801a.png";